import { ABOUT_IMG } from "@/data/menu";
import { Reveal } from "@/components/Reveal";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-brand-bg py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand-accent md:text-sm">
            <span className="mr-3 font-light text-brand-dark/35">01 /</span>
            ЗА B1 &amp; B2
          </p>
          <h2 className="mt-5 font-serif text-3xl font-light leading-snug tracking-tight text-brand-dark md:text-4xl">
            За нас добрият мениджмънт означава спокойствие за клиента.
          </h2>
          <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-brand-gray md:text-base">
            B1 &amp; B2 съчетава опит в кетъринга, организацията и координацията
            на събития, с внимание към всеки детайл — от храната до цялостното
            преживяване.
          </p>
          <p className="mt-8 text-sm font-semibold tracking-[0.15em] text-brand-dark md:text-base">
            Кетъринг <span className="text-brand-accent">•</span> Събития{" "}
            <span className="text-brand-accent">•</span> Координация{" "}
            <span className="text-brand-accent">•</span> Декорация
          </p>
        </Reveal>
        <Reveal delay={150} className="img-zoom overflow-hidden rounded-2xl">
          <img
            src={ABOUT_IMG}
            alt="Екипът на B1 & B2 подрежда кетъринг маса с хапки"
            loading="lazy"
            className="aspect-[4/3] w-full object-cover"
          />
        </Reveal>
      </div>
    </div>
  </section>
);
